module.exports = " <div class=\"container--margin-top\">\n\t<leo-box [pageHeadline]=\"pageHeadline\">\n\t\t<event-with-venue-search-box (searchChange)=\"searchChange($event)\" [search]=\"search\" (resetSearch)=\"resetSearch()\"></event-with-venue-search-box>\n\t</leo-box>\n\t<leo-box>\n\t\t<event-with-venue-list [events]=\"eventsWithVenues$|async\" [orderBy]=\"orderBy$ | async\" (orderByChange)=\"orderByChange($event)\" (navigateToDetailClicked)=\"navigateToDetails($event)\"></event-with-venue-list>\n\t</leo-box>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/events-on-sale/events-on-sale.html
// module id = 1Wva
// module chunks = 12